import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';

// After a guest builds a resume at /build/:type and then signs up, this saves
// their locally-stored draft to the new account so nothing is lost.
export const GuestDraftSync = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const didRun = useRef(false);

  useEffect(() => {
    if (!user || didRun.current) return;
    const draftRaw = localStorage.getItem('mars_guest_draft');
    if (!draftRaw) return;
    didRun.current = true;

    (async () => {
      try {
        const draft = JSON.parse(draftRaw);
        const created = await api.createDoc({
          type: draft.type,
          title: draft.data?.personalInfo?.fullName || 'Untitled',
          template: draft.data?.template || 'modern',
          data: draft.data,
        });
        localStorage.removeItem('mars_guest_draft');
        navigate(`/builder/${draft.type}/${created._id}`);
      } catch {
        // Leave the draft in place — user still lands on the normal post-auth page and can retry later.
      }
    })();
  }, [user]);

  return null;
};
